import {
  FETCH_DATA_FAILURE,
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
} from "./actionType";
import axios from "axios";

/**
 * Request action for fetching user data
 * @returns {Object} Redux action
 */
const fetchDataRequest = () => ({
  type: FETCH_DATA_REQUEST,
});

/**
 * Success action for fetching user data
 * @param {Array} data - User data
 * @returns {Object} Redux action with payload
 */
const fetchDataSuccess = (data) => ({
  type: FETCH_DATA_SUCCESS,
  payload: data,
});

/**
 * Failure action for fetching user data
 * @param {string} error - Error message
 * @returns {Object} Redux action with error payload
 */
const fetchDataFailure = (error) => ({
  type: FETCH_DATA_FAILURE,
  payload: error,
});

/**
 * Thunk action to fetch user data from Random User API
 * @returns {Function} Thunk function
 */
export const fetchUserData = () => (dispatch) => {
  dispatch(fetchDataRequest());
  try {
    fetch("https://randomuser.me/api/?results=40")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => dispatch(fetchDataSuccess(data.results)))
      .catch((error) => {
        console.error("Error fetching user data:", error);
        dispatch(fetchDataFailure(error.message));
      });
  } catch (error) {
    console.error("Unexpected error:", error);
    dispatch(fetchDataFailure(error.message));
  }
};

// ============================================
// PRODUCT ACTIONS for marketplace page
// ============================================

/**
 * Request action for fetching products
 * @returns {Object} Redux action
 */
const fetchProductDataRequest = () => ({
  type: FETCH_PRODUCTS_REQUEST,
});

/**
 * Success action for fetching products
 * @param {Array} data - Product data
 * @returns {Object} Redux action with payload
 */
const fetchProductDataSuccess = (data) => ({
  type: FETCH_PRODUCTS_SUCCESS,
  payload: data,
});

/**
 * Failure action for fetching products
 * @param {string} error - Error message
 * @returns {Object} Redux action with error payload
 */
const fetchProductDataFail = (error) => ({
  type: FETCH_PRODUCTS_FAILURE,
  payload: error,
});

/**
 * Thunk action to fetch product data from DummyJSON API
 * @returns {Function} Thunk function
 */
export const fetchProductData = () => (dispatch) => {
  dispatch(fetchProductDataRequest());
  try {
    axios
      .get("https://dummyjson.com/products?skip=30&limit=12", {
        timeout: 10000,
      })
      .then((response) => {
        if (!response.data || !response.data.products) {
          throw new Error("Invalid response data");
        }
        dispatch(fetchProductDataSuccess(response.data.products));
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
        const errorMessage = error.message || "Failed to fetch products";
        dispatch(fetchProductDataFail(errorMessage));
      });
  } catch (error) {
    console.error("Unexpected error:", error);
    dispatch(fetchProductDataFail(error.message));
  }
};
